<template>
  <svg
    :width="dimensions.width"
    :height="dimensions.height"
    :viewBox="`0 0 ${dimensions.width} ${dimensions.height}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
  <g id="Layer_1" clip-path="url(#clip0_605_5183)">
      <path id="Vector" d="M4.88672 1.74219H41.5507" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <g id="Group">
        <g id="Group_2">
          <path id="Vector_2" d="M14.0525 18.0371C14.0525 18.0371 13.9711 19.0148 13.8285 19.4629C13.6859 19.9314 13.4618 20.3795 13.1767 20.7869C12.8508 21.2554 12.4434 21.6831 11.9749 22.0498C10.8954 22.8849 9.51027 23.3738 7.96223 23.3738C7.26969 23.3738 6.61788 23.2719 6.00682 23.0886C4.62173 22.6812 3.46071 21.8461 2.72742 20.7869C2.17746 19.9722 1.85156 18.0371 1.85156 18.0371H14.0729H14.0525Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"
          />
          <path id="Vector_3" d="M7.94019 3.7793L14.0509 18.0375H1.89062L7.94019 3.7793Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"
          />
        </g>
        <g id="Group_3">
          <path id="Vector_4" d="M44.6072 18.0371C44.6072 18.0371 44.5257 19.0148 44.3832 19.4629C44.2406 19.9314 44.0165 20.3795 43.7314 20.7869C43.4054 21.2554 42.9981 21.6831 42.5296 22.0498C41.45 22.8849 40.065 23.3738 38.5169 23.3738C37.8244 23.3738 37.1726 23.2719 36.5615 23.0886C35.1764 22.6812 34.0154 21.8461 33.2821 20.7869C32.7322 19.9722 32.4062 18.0371 32.4062 18.0371H44.6276H44.6072Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"
          />
          <path id="Vector_5" d="M38.4949 3.7793L44.6055 18.0375H32.4453L38.4949 3.7793Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"
          />
        </g>
      </g>
      <g id="Group_4">
        <path id="Vector_6" d="M23.2216 33.823C25.044 33.823 26.5214 32.373 26.5214 30.5844C26.5214 28.7957 25.044 27.3457 23.2216 27.3457C21.3992 27.3457 19.9219 28.7957 19.9219 30.5844C19.9219 32.373 21.3992 33.823 23.2216 33.823Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"
        />
        <path id="Vector_7" d="M12.2617 31.5209V29.6266C12.2617 28.5063 13.1987 27.5897 14.3393 27.5897C16.3151 27.5897 17.1299 26.2047 16.1318 24.514C15.5615 23.5363 15.9077 22.2735 16.9058 21.7235L18.8001 20.6439C19.6556 20.1347 20.7963 20.4403 21.3055 21.2958L21.4277 21.4994C22.4258 23.1901 24.0349 23.1901 25.033 21.4994L25.1552 21.2958C25.6644 20.4403 26.7847 20.1551 27.6606 20.6439L29.5549 21.7235C30.553 22.2938 30.8993 23.5363 30.3289 24.514C29.3308 26.2047 30.1456 27.5897 32.1214 27.5897C33.262 27.5897 34.199 28.5063 34.199 29.6266V31.5209C34.199 32.6412 33.262 33.5578 32.1214 33.5578C30.1456 33.5578 29.3308 34.9429 30.3289 36.6335C30.8993 37.6112 30.553 38.8741 29.5549 39.4241L27.6606 40.5036C26.8051 41.0128 25.6644 40.7073 25.1552 39.8518L25.033 39.6481C24.0349 37.9575 22.4258 37.9575 21.4277 39.6481L21.3055 39.8518C20.7963 40.7073 19.676 40.9925 18.8001 40.5036L16.9058 39.4241C15.9077 38.8537 15.5615 37.6112 16.1318 36.6335C17.1299 34.9429 16.3151 33.5578 14.3393 33.5578C13.1987 33.5578 12.2617 32.6412 12.2617 31.5209Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"
        />
      </g>
      <path id="Vector_8" d="M23.2188 22.1111V1.74219" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_605_5183">
        <rect width="45.83" height="42.0618" fill="white" transform="translate(0.304688 0.214844)"/>
      </clipPath>
    </defs>
  </svg>

</template>
<script>
export default {
  props: {
    width: {
      required: false,
      type: [Number, String],
      default: 47,
    },
    height: {
      required: false,
      type: [Number, String],
      default: 43,
    },
    useCustomDimensions: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultWidth: 47,
      defaultHeight: 43,
    };
  },
  computed: {
    dimensions() {
      return {
        width: this.useCustomDimensions ? this.width : this.defaultWidth,
        height: this.useCustomDimensions ? this.height : this.defaultHeight,
      };
    },
  },
};
</script>
